module.exports = __webpack_public_path__ + "static/media/ChickenSans-Bold.c4f2795c.woff";